// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,600,700&display=swap);"]);
// Module
exports.push([module.id, ".Footer{background:rgba(0,0,0,0.05)}.Footer .Logo{width:54px;height:54px}.Footer .SeparatorDot{margin:0 16px;width:4px;height:4px;border-radius:100%;background-color:#c2cfe6}.Footer .facebook-icon{width:16px;height:16px;margin-right:8px}\n", ""]);
// Exports
module.exports = exports;
